export const SNACKBAR_LOGOUT_SUCCESS = 'logoutSuccess';
export const SNACKBAR_ERROR = 'error';
export const SNACKBAR_TIMEOUT_SNACKBAR = 'timeout';
export const SNACKBAR_YOUR_PROFILE_UPDATED = 'yourProfileDataUpdated';
export const SNACKBAR_RESET_PASSWORD_EMAIL_SENT = 'resetPasswordEmailSent';
export const SNACKBAR_CANCEL_BOOKING_SUCCESS = 'cancelBooking';

export const SNACKBAR_NAMES = [
  SNACKBAR_LOGOUT_SUCCESS,
  SNACKBAR_ERROR,
  SNACKBAR_TIMEOUT_SNACKBAR,
  SNACKBAR_YOUR_PROFILE_UPDATED,
  SNACKBAR_RESET_PASSWORD_EMAIL_SENT,
  SNACKBAR_CANCEL_BOOKING_SUCCESS,
];
